export default "__VITE_ASSET__BEMWAmd6__"